import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import _ from 'lodash';

import {fetchArticleComments, resetArticleComments} from "../../../creators/article.comments";
import {createSubComment, updateSubComment} from "../../../creators/comments.subComment";
import {createArticleComment, deleteArticleComment, updateArticleComment} from "../../../creators/article.comment";

import Comment from './components/Comment';
import {SpinLoader} from "../Loader";
import createLink from "../../../libs/createLink";
import {reportArticleComment} from "../../../creators/report";
import CommentEditor from "./components/CommentEditor/CommentEditor";
import {Can} from "../../../ability-context";
import {fetchUserFriends} from "../../../creators/user.friends";

class ArticleComments extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            parentId: this.props.articleId || 0,
            page: 1,
            limit: 10,
            sort: "-createdAt"
        };
        this.initialSubCommentAnswer = {
            owner: {},
            commentId: ""
        };
        this.state = {
            edit : {},
            isNextComment: false,
            filter: this.filter,
            articleComments: [],
            subCommentAnswer: this.initialSubCommentAnswer,
            isAnsweringComment: false,
        };
        this.fetchComments = this.fetchComments.bind(this);
        this.commentsNext = this.commentsNext.bind(this);
        // this.updateArticleComment = this.updateArticleComment.bind(this);
        this.deleteArticleComment = this.deleteArticleComment.bind(this);
        this.handleReport = this.handleReport.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubCommentAnswer = this.handleSubCommentAnswer.bind(this);
        this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);

        this.fetchComments(this.state.filter);
        if(this.props.currentUserInitialized && this.props.currentUserId && !this.props.userFriendsInitialized){
            this.props.fetchUserFriends(this.props.currentUserId);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.articleId !== this.props.articleId) {
            this.props.resetArticleComments();
            this.fetchComments(this.state.filter, false);
        }
    }

    componentWillUnmount() {
        this.props.resetArticleComments();
    }

    fetchComments(filter, more) {
        filter = {...filter};
        this.props.fetchArticleComments(this.props.articleId, filter, more);
    }

    commentsNext() {
        let page = this.state.filter.page + 1;
        let newFilter = {...this.state.filter, page};
        this.setState({filter: newFilter});
        this.fetchComments(newFilter, true);
    }

    // updateArticleComment(id, value) {
    //     this.props.updateArticleComment(this.props.articleId, id, {content: value});
    // }

    deleteArticleComment(id) {
        this.props.deleteArticleComment(this.props.articleId, id);
    }

    handleReport(id, message){
        this.props.reportArticleComment(this.props.articleId, id, {message})
    }

    handleSubCommentAnswer(commentId, ownerOfSubComment){
        this.setState({subCommentAnswer: {
                owner: ownerOfSubComment,
                commentId
            }});
    }

    resetSubCommentAnswer(){
        this.setState({subCommentAnswer: this.initialSubCommentAnswer, isAnsweringComment: false});
    }

    handleSubmit(value) {
        if(this.state.subCommentAnswer.commentId){
            this.props.createSubComment(this.props.commentType, this.props.articleId, this.state.subCommentAnswer.commentId, value);
            this.setState({isAnsweringComment: true}, ()=>this.resetSubCommentAnswer());
        } else {
            this.props.createArticleComment(this.props.articleId, value);
            this.setState({subCommentAnswer: this.initialSubCommentAnswer})
        }

    }

    handleSubmitEdit({
                         parentId,
                         parentCommentId,
                         commentId,
                         commentType,
                     }, contentState) {
        if (parentCommentId) {
            this.props.updateSubComment(commentType, parentId, parentCommentId, commentId, contentState);
        }
        else {
            this.props.updateArticleComment(parentId, commentId, contentState);
        }

        this.setState({edit:{}});
    }

    handleEdit({
                   parentId,
                   parentCommentId,
                   commentId,
                   text,
                   mentions,
                   commentType
               }){
        this.setState({edit : {
                parentId,
                parentCommentId,
                commentId,
                text,
                mentions,
                commentType
            }});
    }

    render() {
        let comments = [...this.props.articleComments];
        let canOptions = {
            subject: this.props.article,
            modelName: "Comment",
            action: "create",
            passThrough: true
        };

        return (
            <div className="column">
                <div className="comments">
                    <div className="comments-list">
                        {!this.props.articleCommentsInitialized && _.times(5).map((item, index) => (
                            <Comment key={index} commentsInitialized={false}/>
                        ))}
                        {this.props.articleCommentsInitialized && !this.props.articleCommentsLoading && this.props.articleCommentsTotal === 0 && (
                            <div className={"no-content"}>Aucun commentaire</div>
                        )}
                        {comments.map((comment) => (
                            <Comment
                                key={comment._id}
                                {...comment}
                                handleEdit={this.handleEdit}
                                currentUser={this.props.currentUser}
                                parentId={this.props.articleId}
                                commentsInitialized={this.props.articleCommentsInitialized}
                                deleteComment={this.deleteArticleComment}
                                /*updateComment={this.updateArticleComment}*/
                                handleReport={this.handleReport}
                                handleSubCommentAnswer={this.handleSubCommentAnswer}
                                commentType={this.props.commentType}
                                subCommentAnswer={this.state.subCommentAnswer}
                                isAnsweringComment={this.state.isAnsweringComment}
                            />
                        ))}
                        {!this.props.articleCommentsLoading && this.props.articleCommentsMore && (
                            <div className="more-comments" onClick={() => this.commentsNext()}>
                                Voir plus de commentaires
                            </div>
                        )}
                        {this.props.articleCommentsLoading && this.props.articleCommentsMore && (
                            <div className="more-comments loading" onClick={() => this.commentsNext()}>
                                <SpinLoader className={"small"}/>
                            </div>
                        )}
                    </div>
                    {this.props.article.comment.allowed ? (
                        <Can {...canOptions}>
                            {can=>(
                                <CommentEditor
                                    mentions={this.props.userFriends}
                                    onSubmit={this.handleSubmit}
                                    onSubmitEdit={this.handleSubmitEdit}
                                    onCancelRespond={()=>{
                                        this.setState({subCommentAnswer: this.initialSubCommentAnswer})
                                    }}
                                    onCancelEdit={()=>{
                                        this.setState({edit: {}})
                                    }}
                                    edit={this.state.edit}
                                    respondMention={this.state.subCommentAnswer.owner}
                                    cannot={!can}
                                />)}
                        </Can>
                    ) : (
                        <div className="close-comments">
                            {this.props.currentUser._id ? "Commentaires fermés par l’auteur" : <span>Veuillez vous <Link
                                to={createLink("signin")}>connecter</Link> pour publier un commentaire</span>}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        articleComments: state.articleComments.data,
        articleCommentsLoading: state.articleComments.loading,
        articleCommentSubmitting: state.articleComments.submitting,
        articleCommentsInitialized: state.articleComments.initialized,
        articleCommentsTotal: state.articleComments.total,
        articleCommentsMore: state.articleComments.more,

        articleComment: state.articleComment.data,
        articleCommentLoading: state.articleComment.loading,

        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
        currentUserId: state.currentUser.data && state.currentUser.data._id,
        userFriends: state.userFriends.data,
        userFriendsInitialized: state.userFriends.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchArticleComments,
    resetArticleComments,

    createArticleComment,
    updateArticleComment,
    deleteArticleComment,
    reportArticleComment,

    createSubComment,
    fetchUserFriends,
    updateSubComment,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ArticleComments);
